"use client";
import { useTranslations } from "next-intl";
import CardListItem from "./CardListItem";

export default function CardList({ items, type }: any) {
  const t = useTranslations('Filters');
  return (
    <div className="">
      <span className="text-l-regular text-neutral-900">
        {items?.length} {t("result")}{items?.length > 1 ? "s" : ""}
      </span>
      <div className="mt-32 border-t border-neutral-200" role="separator" aria-hidden="true"></div>
      <div className="list-none p-0 m-0">
        {items.map((video: any, index: number) => (
          <CardListItem key={index} video={video} type={type} />
        ))}
      </div>
    </div>
  );
}
